import WriteTextOnCanvas from './utils/WriteTextOnCanvas';
import loadImage from './utils/loadImage';

type CreateAmbitionResponse = {
    ambitionUrl: string
}

document.body.onload = async () => {
  const fude = new FontFace('fude', 'url(../fonts/fude.ttf)');
  await fude.load();
  document.fonts.add(fude);

  const KouzanMouhituFontOTF = new FontFace('KouzanMouhituFontOTF', 'url(../fonts/KouzanMouhituFontOTF.otf)');
  await KouzanMouhituFontOTF.load();
  document.fonts.add(KouzanMouhituFontOTF);

  const csrf = document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement;
  const canvas = document.getElementById('ambition-canvas') as HTMLCanvasElement;
  const ambitionTextarea = document.getElementById('ambition') as HTMLTextAreaElement;
  const ambitionCanvasDownloadButton = document.getElementById('ambition-canvas-download') as HTMLButtonElement;
  const modeToggle = document.getElementById('mode-toggle') as HTMLInputElement;
  const shareButton = document.getElementById('ambition-share') as HTMLButtonElement;
  const tweetAmbitionForm = document.getElementById('tweet-ambition') as HTMLFormElement;

  const vertical = await loadImage('/images/vertical.jpg') as HTMLImageElement;
  const verticalFontSize = 16 * 13; // 13rem
  const horizon = await loadImage('/images/horizon.jpg') as HTMLImageElement;
  const horizonFontSize = 16 * 6; // 6rem

  const writeTextOnCanvas = new WriteTextOnCanvas({
    canvas: canvas,
    image: vertical,
    font: 'KouzanMouhituFontOTF',
    fontSize: verticalFontSize,
    fontColor: '#404040',
  });

  writeTextOnCanvas.write(ambitionTextarea.value);

  ambitionTextarea.addEventListener('input', (e) => {
    const target = e.target as HTMLTextAreaElement;
    writeTextOnCanvas.write(target.value);
  });

  ambitionCanvasDownloadButton.addEventListener('click', async (e) => {
    e.preventDefault();
    e.stopPropagation();

    await fetch('/api/ambitions', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        'ambitionImage': writeTextOnCanvas.toDataURL(),
        'ambitionText': writeTextOnCanvas.text(),
        '_token': csrf.content
      })
    });

    writeTextOnCanvas.toBlob((blob) => {
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = '今年の抱負';
      link.click();
      URL.revokeObjectURL(link.href);
    });
  });

  modeToggle.addEventListener('input', (e) => {
    const target = e.target as HTMLInputElement;
    writeTextOnCanvas.changeMode(target.checked ? 'horizon' : 'vertical');
    writeTextOnCanvas.changeImage(target.checked ? horizon : vertical);
    writeTextOnCanvas.changeFontSize(target.checked ? horizonFontSize : verticalFontSize);
  });

  shareButton.addEventListener('click', async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const response = await fetch('/api/ambitions', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        'ambitionImage': writeTextOnCanvas.toDataURL(),
        'ambitionText': writeTextOnCanvas.text(),
        '_token': csrf.content
      })
    });

    const data = await response.json() as CreateAmbitionResponse;
    const ambitionUrl = data.ambitionUrl;

    const url = new URL('https://twitter.com/intent/tweet');
    const urlSearchParams = new URLSearchParams(url.search);
    urlSearchParams.append('url', ambitionUrl + '\n');
    urlSearchParams.append('text', writeTextOnCanvas.text() + '\n\n');
    urlSearchParams.append('hashtags', ['今年の抱負\n', '書き初め\n', '今年の抱負メーカー'].join(','));

    const shareUrl = new URL(`${url.origin}${url.pathname}?${urlSearchParams}`);

    const link = document.createElement('a');
    link.href = shareUrl.href;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.click();
  });

  tweetAmbitionForm.addEventListener('submit', () => {
    const input = document.querySelector('form input[name="ambitionImage"]') as HTMLInputElement;
    input.value = writeTextOnCanvas.toDataURL();
  });
};
